module.exports = __webpack_public_path__ + "img/Screen_5.95fa69cb.png";